import { createContext, useEffect, useState } from 'react';
import { auth } from '../../useFirebaseInit';
import { useDispatch } from 'react-redux';
import Toast from '../../components/toast/Toast';
import Styles from "./ToasContextProvider.module.scss";
import { setNotifications } from '../../actions/notifications';

export const ToastContext = createContext();

export default function ToastContextProvider({ children }) {

  const [isVisible, setIsVisible] = useState(true);
  const [isClosed, setIsClosed] = useState(false)
  const [toasts, setToasts] = useState({})

  const dispatch = useDispatch()

  useEffect(()=>{},[])

  const showToast = (toastInformation, autoHide = true, addtoControlPanelNotificatrion = false, autoHideDelay = 8500) => {
    setIsVisible(true)

    setToasts({
      ...toastInformation
    })

    if (autoHide) {
      setTimeout(() => {
        setIsVisible(false)
        addtoControlPanelNotificatrion && !isClosed && dispatch(setNotifications(toastInformation))
      }, autoHideDelay)
    }
  }

  const removeToast = (id) => {

    const updatedObject = { ...toasts };

    if (id in updatedObject) {
      delete updatedObject[id];

      setToasts(updatedObject);
    }


    if (!toasts) {
      setIsClosed(true)
      setIsVisible(false)
    }
  }

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {!isClosed && isVisible && toasts && (
        <div className={Styles.container}>
          {
            Object.keys(toasts).map((key,index) => {
              return <Toast index={index} toast={toasts[key]} id={key} onClose={removeToast} key={key} />
            })
          }
        </div>
      )}
    </ToastContext.Provider>
  )
}
